import {PatientPriorityStatus} from "doctors-dashboard/http-clients/index";
import {parseEnum} from "orpyx-web-common";

/// <summary>
/// <para>Statuses that can be pinned to the top of the Inactive Patients list.</para>
/// <para>The backend reads PriorityStatus only when OrderBy is Status, and accepts a single value.</para>
/// </summary>
export const PatientPriorityStatuses: PatientPriorityStatus[] = [
    PatientPriorityStatus.Paused,
    PatientPriorityStatus.Discontinued,
];

/// <summary>
/// <para>The Inactive Patients list always pins a status; paused patients sit on top unless the
/// user picks otherwise.</para>
/// </summary>
export const DEFAULT_PATIENT_PRIORITY_STATUS: PatientPriorityStatus = PatientPriorityStatus.Paused;

export const PatientPriorityStatusPipe = (status?: PatientPriorityStatus | null): string => {
    switch (status) {
        case PatientPriorityStatus.Paused:
            return 'Paused first';
        case PatientPriorityStatus.Discontinued:
            return 'Discontinued first';
    }
    return 'Default order';
};

/// <summary>
/// <para>Falls back to the default rather than "no pinning", which the list no longer offers.</para>
/// </summary>
export const parsePriorityStatus = (value: string | undefined): PatientPriorityStatus => {
    if (!value)
        return DEFAULT_PATIENT_PRIORITY_STATUS;

    const status = parseEnum(PatientPriorityStatus, value.trim(), undefined);

    return !!status && PatientPriorityStatuses.includes(status) ? status : DEFAULT_PATIENT_PRIORITY_STATUS;
};
